/* eslint-disable*/
import React from 'react';
import PropTypes from 'prop-types';
import MultiplasDestinacoes from '../templates/MultiplasDestinacoes';
import validarCNPJ from '../../../utils/validator/cnpjValidator';
import ModalDestinacao from './ModalDestinacao';
import { doGet, trataMensagensErro } from '../../../utils/requests';

const camposComponenteParticipantes = [
  'codigoParticipante', 'tipoRegime', 'tipoEntidade', 'uf',
];

const camposValidaveis = [
  'codigoParticipante', 'nomeOrgao', 'cnpj',
];

const camposDestinatario = [
  'codigoParticipante', 'nomeOrgao', 'cnpj', 'matricula',
];

// const camposExibicaoModal = [
//   'subEstadoFormulario', 'estadoFormulario', 'exibirBotaoIncluirInicial', 'showModal',
// ];

const tipoRegimeRGPS = 1;
const NOME_RGPS = 'RGPS';
const CODIGO_RGPS = '01000';
const VAZIO = '';
// const pemissoesAcaoPrincipal = ['analisar-compensacao-rpps', 'requerer-compensacao-rpps'];

class CtcDestinacao extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState(props);
  }

  getInitialState = () => ({
    ctcDestinacao: {
      codigoParticipante: null,
      nomeOrgao: null,
      cnpj: null,
      matricula: null,
      nomeParticipante: null,
      indiceDestinacao: null,
    },
    validadeCampos: {
      codigoParticipante: false,
      nomeOrgao: false,
      // cnpj: false,
    },
    codigoParticipante: null,
    tipoRegime: null,
    tipoEntidade: null,
    uf: null,
    estadoFormulario: 'incluir',
    subEstadoFormulario: null,
    exibirBotaoIncluirInicial: false,
    tituloBotao: 'adicionar destinário',
    showModal: false,
    requestPesquisa: null,
  });

  componentDidMount() {
    // this.montarListaParticipantesEscolhidos();
    this.atualizarEstadoFormulario();
    this.verificarExibicaoBotaoInclusaoInicial();
  }

  atualizarEstadoFormulario = () => {
    const acaoPrincipal = this.props.statePrincipal.acao;
    let retorno = null;
    switch (acaoPrincipal) {
      case 'novo':
          retorno = 'incluir';
        break;
      //case 'alterar-ctc':
      case 'editar-rascunho':
          retorno = 'alterar';
        break;
      default:
      break;
    }
    this.setState({
      estadoFormulario: retorno,
    });
  }

  verificarExibicaoBotaoInclusaoInicial = () => {
    const exibirBotaoInicial = this.props.verificarExibicaoBotaoIncluirDestinacao();
    if (exibirBotaoInicial) {
      this.setState({
        exibirBotaoIncluirInicial: true,
      });
    }
  }

  handleChange = (changeObj, name) => {
    const { ctcDestinacao } = { ...this.state };
    const { validadeCampos } = { ...this.state };

    if (camposComponenteParticipantes.includes(name)) {
      const { tipoRegime } = { ...this.state };

      if (name === 'tipoRegime' && changeObj.value === tipoRegimeRGPS) {
        validadeCampos.codigoParticipante=true;
        this.setState({
          ctcDestinacao: {
            ...ctcDestinacao,
            codigoParticipante: CODIGO_RGPS,
            validadeCampos,
          },
        });
      } else if (name === 'tipoRegime' && tipoRegimeRGPS !== changeObj.value) {
          if (tipoRegime !== changeObj.value) {
            this.setState({
              codigoParticipante: null,
              tipoEntidade: null,
              uf: null,
            });
          }
          if (tipoRegimeRGPS !== changeObj.value) {
            validadeCampos.tipoEntidade = false;
            validadeCampos.codigoParticipante = false;
          }
      }

      if (name === 'tipoEntidade') {
        if (changeObj.value === 2) {
          validadeCampos.uf = false;
        }
        validadeCampos.codigoParticipante = false;
      }
      if (name === 'uf' && changeObj.value !== null && changeObj.value !== '') {
        validadeCampos.codigoParticipante = false;
      }
      if (name === 'codigoParticipante') {
        validadeCampos.codigoParticipante = true;
      }
      this.setState({
        [name]: changeObj.value,
        validadeCampos: {
          ...validadeCampos,
          [name]: changeObj.isValid,
        }
      });
    }

    if (['subEstadoFormulario', 'estadoFormulario', 'exibirBotaoIncluirInicial', 'showModal'].includes(name)) {
      this.setState({
        [name]: changeObj.value,
      });
    }

    if (camposValidaveis.includes(name)) {
      this.setState({
        validadeCampos: {
          ...validadeCampos,
          [name]: changeObj.isValid,
        }
      });
    } 

    if (camposDestinatario.includes(name)) {
      this.setState({
        ctcDestinacao: {
          ...ctcDestinacao,
          [name]: changeObj.value,
        },
      });
    }
  }

  resetarValidadeCampos = () => {
    const validadeCamposReset = {
      codigoParticipante: false,
      nomeOrgao: false,
    }
    this.setState({
      validadeCampos: validadeCamposReset,
    });
  }

  resetarObjetoDestinacao = () => {
    const destinacaoReset = {
      codigoParticipante: VAZIO,
      nomeOrgao: VAZIO,
      cnpj: VAZIO,
      matricula: VAZIO,
    };

    this.setState({
      ctcDestinacao: destinacaoReset,
      codigoParticipante: VAZIO,
      tipoRegime: VAZIO,
      tipoEntidade: VAZIO,
      uf: this.state.uf ? VAZIO : null,
    }, this.resetarValidadeCampos);
  }

  carregarVariaveisControlesTela = (ctcDestinacao) => {
    const { participantesEscolhidos } = { ...this.props.statePrincipal };
    if ( participantesEscolhidos.length > 0 ) {
      if (ctcDestinacao.codigoParticipante === CODIGO_RGPS) {
        // ctcDestinacao.codigoParticipante = '01000';
        this.setState({
          codigoParticipante: '01000',
          tipoRegime: 1,
        });
      } else {
        const index = participantesEscolhidos.findIndex(p => (p.codigoParticipante === ctcDestinacao.codigoParticipante));
        if (index !== -1) {
          this.setState({
            codigoParticipante: participantesEscolhidos[index].codigoParticipante,
            tipoRegime: participantesEscolhidos[index].tipoRegime,
            tipoEntidade: participantesEscolhidos[index].tipoEntidade,
            uf: participantesEscolhidos[index].uf,
          });
        }
      }
    }
  }

  validarCamposDestinatario = (ctcDestinacao) => {
    let { validadeCampos } = { ...this.state };
    if (ctcDestinacao.codigoParticipante !== null && ctcDestinacao.codigoParticipante !== VAZIO) {
      validadeCampos.codigoParticipante = true;
    }
    if (ctcDestinacao.nomeOrgao !== null && ctcDestinacao.nomeOrgao !== VAZIO) {
      validadeCampos.nomeOrgao = true;
    }
    if (ctcDestinacao.cnpj !== null && ctcDestinacao.cnpj !== VAZIO) {
      validadeCampos.cnpj = true;
    }
    this.setState({
      validadeCampos,
    });
  }

  handleCarregarAlteracaoDestinacao = (row) => {
    let { destinacoes } = { ...this.props.statePrincipal.ctc };
    // let { exibirPainelDestinacao } = { ...this.props.estadoFormulario };
    
    let ctcDestinacao = {
      codigoParticipante: destinacoes[row].codigoParticipante,
      nomeOrgao: destinacoes[row].nomeOrgao,
      cnpj: destinacoes[row].cnpj,
      matricula: destinacoes[row].matricula,
      indice: destinacoes[row].indice,
      indiceDestinacao: destinacoes[row].indiceDestinacao,
    }

    this.carregarVariaveisControlesTela(ctcDestinacao);
    this.validarCamposDestinatario(ctcDestinacao);

    this.setState({
      estadoFormulario: 'alterar',
      ctcDestinacao,
      tituloBotao: 'alterar destinatário',
      subEstadoFormulario: 'alterar-destinacao',
      exibirBotaoIncluirInicial: false,
      showModal: !this.state.showModal,
    });
  }

  handleCarregarDetalhamentoDestinacao = (row) => {
    let { destinacoes } = { ...this.props.statePrincipal.ctc };
    
    let ctcDestinacao = {
      codigoParticipante: destinacoes[row].codigoParticipante,
      nomeOrgao: destinacoes[row].nomeOrgao,
      cnpj: destinacoes[row].cnpj,
      matricula: destinacoes[row].matricula,
      indice: destinacoes[row].indice,
      indiceDestinacao: destinacoes[row].indiceDestinacao,
    }

    this.carregarVariaveisControlesTela(ctcDestinacao);
    this.validarCamposDestinatario(ctcDestinacao);

    this.setState({
      estadoFormulario: 'detalhar',
      ctcDestinacao,
      tituloBotao: '',
      subEstadoFormulario: 'detalhar-destinacao',
      exibirBotaoIncluirInicial: false,
      showModal: !this.state.showModal,
    });
  }

  contarDestinacoesIncluidas = () => {
    let { destinacoes } = { ...this.props.statePrincipal.ctc };
    let retorno = 0;
    if (!destinacoes || (destinacoes && destinacoes.length === 0)) {
      retorno = 1;
    } else {
      let lista = [];
      destinacoes.forEach((ctcDestinacao) => {
        lista.push(ctcDestinacao.indiceDestinacao);
      });
      switch (lista.length) {
        case 1:
          retorno = 2;
          break;
        case 2:
          retorno = 3;
          break;
        default:
          break;
      }
    }
    return retorno;
  } 

  compararDestinacoes = (a, b) => {
    if (a.indiceDestinacao < b.indiceDestinacao) {
      return -1;
    }
    if (a.indiceDestinacao > b.indiceDestinacao) {
      return 1;
    }
    return 0;
  }

  ordenarLista = (lista) => {
    lista.sort(this.compararDestinacoes);
    return lista;
  }

  verificarTipoEntidade = (objetoIndex) => {
    return objetoIndex.tipoRegimeProprio;
  }

  handleManterDestinacao = () => {
    let { destinacoes } = { ...this.props.statePrincipal.ctc };
    let { ctcDestinacao } = { ...this.state };
    const cnpjValido = this.validarCnpj(this.state.ctcDestinacao.cnpj);
    let { subEstadoFormulario } = { ...this.state };
    if (!cnpjValido) {
      trataMensagensErro(['CNPJ Inválido. Informe um CNPJ válido.']);
    } else {
      // this.montarListaParticipantesEscolhidos(ctcDestinacao);
      //RECUPERAR O NOME DO PARTICIPANTE PARA EXIBIR NA LISTAGEM
      ctcDestinacao.nomeParticipante = this.recuperarNomeParticipante();
        switch (subEstadoFormulario) {
          case 'incluir-destinacao':
            if(ctcDestinacao.codigoParticipante === NOME_RGPS) {
                ctcDestinacao.codigoParticipante = '01000';
            }
            ctcDestinacao.indiceDestinacao = this.contarDestinacoesIncluidas();
            if (!destinacoes) {
              destinacoes = [];
            }
            destinacoes.push(ctcDestinacao);
          break;
          case 'alterar-destinacao':
            const index = destinacoes.findIndex(destinacao => (destinacao.indice === ctcDestinacao.indice));
            let { atividades } = { ...this.props.statePrincipal.ctc };
            if (index !== -1) {
              let ctcDestinacaoAlterado = {
                codigoParticipante: ctcDestinacao.codigoParticipante,
                nomeParticipante: ctcDestinacao.nomeParticipante,
                nomeOrgao: ctcDestinacao.nomeOrgao,
                cnpj: ctcDestinacao.cnpj,
                matricula: ctcDestinacao.matricula,
                indice: ctcDestinacao.indice,
                indiceDestinacao: ctcDestinacao.indiceDestinacao,
              }
              destinacoes.splice(index, 1);
              destinacoes.push(ctcDestinacaoAlterado);
              if (atividades && atividades.length > 0 ) {
                atividades.forEach((ctcAtividade) => {
                  if (ctcAtividade.temposCertificados && ctcAtividade.temposCertificados.length > 0) {
                    let temposCertificados = ctcAtividade.temposCertificados;
                    const index = temposCertificados.findIndex(temposCertificados => (temposCertificados.indiceDestinatario === ctcDestinacaoAlterado.indiceDestinacao));
                    if (index !== -1) {
                      temposCertificados[index].nomeParticipante = this.props.recuperarNomeParticipante(ctcDestinacaoAlterado);
                    }
                  }
                });
              } else {
                const { atividadeTemporaria }= { ...this.props.statePrincipal };
                if (atividadeTemporaria && (atividadeTemporaria.temposCertificados && atividadeTemporaria.temposCertificados.length > 0)) {
                  let temposCertificados = atividadeTemporaria.temposCertificados;
                  const index = temposCertificados.findIndex(temposCertificados => (temposCertificados.indiceDestinatario === ctcDestinacaoAlterado.indiceDestinacao));
                  if (index !== -1) {
                    temposCertificados[index].nomeDestinacao = this.props.recuperarNomeParticipante(ctcDestinacaoAlterado);
                  }
                  this.props.handleChange({ value: null, isValid: true }, 'atividadeTemporaria');
                }
              }
            } else {
              ctcDestinacao.indiceDestinacao = this.contarDestinacoesIncluidas();
              destinacoes.push(ctcDestinacao);
            }
            destinacoes = this.ordenarLista(destinacoes);
          break;
          default:
            break;
        }
      this.props.handleChange({ value: destinacoes, isValid: destinacoes.length > 0 }, 'destinacoes');
      this.props.montarListaDestinacaoTempoCertificado(destinacoes);
      this.props.desabilitarCheckboxMatriculaEDestinacao();
      this.props.popularListaParticipantesEscolhidos(this.props.statePrincipal.ctc);
      this.verificarExibicaoBotaoInclusaoInicial();
      this.resetarObjetoDestinacao();
      this.handleCancelarAcao();
    }
  }

  atualizarContadorDestinacoes = (row) => {
    let { destinacoes } = { ...this.props.statePrincipal.ctc };
    let { acao } = { ...this.props.statePrincipal };
    let lista = [];
    if (acao === 'alterar-ctc') {
      // zerar os indices
      lista = destinacoes.map((item, i) => {
        const itemIndexado = item;
        itemIndexado.indice = i;
        return itemIndexado;
      });
    } else {
      lista = destinacoes.map((item, i) => {
        const itemIndexado = item;
        itemIndexado.indiceDestinacao = ++i;
        return itemIndexado;
      }, this.props.atualizarParticipantesEscolhidosAposExcluir(row));
    }

    this.setState({
      destinacoes: lista,
    });
  }

  handleExcluirDestinacao = (row) => {
    let { destinacoes } = { ...this.props.statePrincipal.ctc };
    let { atividades } = { ...this.props.statePrincipal.ctc };
    let { linhasDestinacaoDesabilitar } = { ...this.props.statePrincipal };

    destinacoes.splice(row, 1);

    this.atualizarContadorDestinacoes();
    this.props.montarListaDestinacaoTempoCertificado(destinacoes);
    if(atividades) {
      linhasDestinacaoDesabilitar.splice(row, 1);
      // this.props.desabilitarCheckboxMatriculaEDestinacao();
    }
    this.setState({
      exibirBotaoIncluirInicial: true,
      subEstadoFormulario: 'excluir-destinacao',
    }, this.props.desabilitarCheckboxMatriculaEDestinacao());
    this.resetarObjetoDestinacao();
  }

  recuperarNomeParticipante = () => {
    const destinatarios = this.props.destinatarios;
    let { ctcDestinacao } = { ...this.state };
    let nome = VAZIO;
    if (ctcDestinacao && ctcDestinacao.codigoParticipante === NOME_RGPS) {
      nome = NOME_RGPS;
    } else {
      const index = destinatarios.findIndex(destinacao => (destinacao.value === ctcDestinacao.codigoParticipante));
      if (index !== -1) {
        nome = destinatarios[index].label;
      }
    }
    return nome;
  }

  validarCnpj = cnpj => (
    validarCNPJ(cnpj)
  )

  handleCancelarAcao = () => {
    this.resetarObjetoDestinacao();
    this.setState({
      estadoFormulario: 'incluir',
      tituloBotao: 'incluir destinatário',
      subEstadoFormulario: 'incluir-destinacao',
      exibirBotaoIncluirInicial: true,
      showModal: !this.state.showModal,
    });
  }

  montaFormularioDadosCnpj = (response) => {
    const { ctcDestinacao } = { ...this.state };
    const { requestPesquisa } = { ...this.state };
    let { validadeCampos } = { ...this.state };   

    const nomeEmpresa = response.data.nome;
    if (nomeEmpresa !== null && nomeEmpresa !== '' && nomeEmpresa !== undefined) {
      validadeCampos[requestPesquisa] = true;
    } else {
      validadeCampos[requestPesquisa] = false;
    }
    ctcDestinacao[requestPesquisa] = nomeEmpresa;
    
    this.setState({
      [requestPesquisa]: nomeEmpresa,
      validadeCampos,
    });
  }

  trataSucessoResponsePesquisaCnpj = (response) => {
    this.montaFormularioDadosCnpj(response);
  }

  trataErrosResponse = (error) => {
    if (error) {
      if (error.status === 404) {
        console.log('erro 404');
      }
    }
  }

  handleSearchCNPJ = (nome, cnpj) => {
    this.setState(
      { requestPesquisa: nome },
      doGet(
        `pessoas-juridicas/${cnpj}`,
        this.trataSucessoResponsePesquisaCnpj,
        this.trataErrosResponse,
      ),
    );
  }

  handleSearchCnpjButton = (nome, cnpj) => {
    this.setState(this.handleSearchCNPJ(nome, cnpj));
  }

  render () {
    return (
      <div>
        <MultiplasDestinacoes
          id={1}
          statePrincipal={this.props.statePrincipal}
          ctcDestinacao={this.state}
          handleChange={this.handleChange}
          titulo='Destinatários'
          retirarLinhaSeparadora={false}
          handleCarregarAlteracaoDestinacao={this.handleCarregarAlteracaoDestinacao}
          handleCarregarDetalhamentoDestinacao={this.handleCarregarDetalhamentoDestinacao}
          handleExcluirDestinacao={this.handleExcluirDestinacao}
          recuperarNomeParticipante={this.props.recuperarNomeParticipante}
          ordenarLista={this.ordenarLista}
          verificarExibicaoBotaoIncluirDestinacao={this.props.verificarExibicaoBotaoIncluirDestinacao}
          incluirNovaDestinacao={this.incluirNovaDestinacao}
        />
          { this.state.showModal ? (
            <ModalDestinacao
              {...this.props}
              handleCancelarAcao={this.handleCancelarAcao}
              handleChange={this.handleChange}
              handleManterDestinacao={this.handleManterDestinacao}
              showModal={this.state.showModal}
              stateDestinatario={this.state}
              statePrincipal={this.props.statePrincipal}
              handleSearchCnpjButton={this.handleSearchCnpjButton}
            />
          ) : ''}
      </div>
    );
  }
};

CtcDestinacao.propTypes = {
  statePrincipal: PropTypes.objectOf(PropTypes.object).isRequired,
  handleChange: PropTypes.func.isRequired,
  verificarExibicaoBotaoIncluirDestinacao: PropTypes.func.isRequired,
  montarListaDestinacaoTempoCertificado: PropTypes.func.isRequired,
  recuperarNomeParticipante: PropTypes.func.isRequired,
  desabilitarCheckboxMatriculaEDestinacao: PropTypes.func.isRequired,
  popularListaParticipantesEscolhidos: PropTypes.func.isRequired,
  atualizarParticipantesEscolhidosAposExcluir: PropTypes.func.isRequired,
};

export default CtcDestinacao;



// WEBPACK FOOTER //
// ./src/pages/repositorio-ctc/templates/CtcDestinacao.jsx